/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./login-callback.page.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./login-callback.page";
import * as i3 from "../../../core/services/Session";
import * as i4 from "@angular/router";
var styles_LoginCallbackPageComponent = [i0.styles];
var RenderType_LoginCallbackPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_LoginCallbackPageComponent, data: {} });
export { RenderType_LoginCallbackPageComponent as RenderType_LoginCallbackPageComponent };
export function View_LoginCallbackPageComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "h4", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["Redirecting..."]))], null, null); }
export function View_LoginCallbackPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_LoginCallbackPageComponent_0, RenderType_LoginCallbackPageComponent)), i1.ɵdid(1, 114688, null, 0, i2.LoginCallbackPageComponent, [i3.SessionService, i4.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LoginCallbackPageComponentNgFactory = i1.ɵccf("ng-component", i2.LoginCallbackPageComponent, View_LoginCallbackPageComponent_Host_0, {}, {}, []);
export { LoginCallbackPageComponentNgFactory as LoginCallbackPageComponentNgFactory };
